import { Star, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

const GOOGLE_PROFILE_URL = "https://g.page/r/CdSQ2GSO16LsEBM";
const GOOGLE_REVIEW_URL = "https://g.page/r/CdSQ2GSO16LsEBM/review";

const GoogleG = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className}>
    <path fill="#4285F4" d="M23.5 12.27c0-.85-.08-1.66-.22-2.45H12v4.64h6.45a5.52 5.52 0 0 1-2.39 3.62v3h3.87c2.26-2.09 3.57-5.16 3.57-8.81z" />
    <path fill="#34A853" d="M12 24c3.24 0 5.96-1.07 7.94-2.91l-3.87-3c-1.07.72-2.44 1.15-4.07 1.15-3.13 0-5.78-2.11-6.73-4.96H1.29v3.1A12 12 0 0 0 12 24z" />
    <path fill="#FBBC05" d="M5.27 14.28A7.2 7.2 0 0 1 4.89 12c0-.79.14-1.56.38-2.28v-3.1H1.29a12 12 0 0 0 0 10.76l3.98-3.1z" />
    <path fill="#EA4335" d="M12 4.77c1.76 0 3.35.61 4.6 1.8l3.42-3.42A11.97 11.97 0 0 0 12 0 12 12 0 0 0 1.29 6.62l3.98 3.1C6.22 6.88 8.87 4.77 12 4.77z" />
  </svg>
);

const Stars = () => (
  <div className="flex gap-0.5">
    {[...Array(5)].map((_, s) => (
      <Star key={s} className="w-4 h-4 text-[#FBBC04]" fill="currentColor" strokeWidth={0} />
    ))}
  </div>
);

const testimonials = [
  {
    name: "Felipe Natan",
    car: "Hyundai HB20",
    text: "Atendimento rápido e serviço especializado no local. Auto elétrica móvel de verdade — recomendo demais.",
    time: "Avaliação do Google",
  },
  {
    name: "Fernanda C.",
    car: "Audi Q3",
    text: "O carro não dava partida na garagem do prédio. Veio com motor de arranque novo a bordo e trocou ali mesmo. Preço fechado antes de sair de casa. Impecável.",
    time: "há 1 mês",
  },
  {
    name: "Paulo H.",
    car: "Mercedes Sprinter",
    text: "Minha van é meu trabalho. Bomba de combustível morreu na rodovia e em menos de 40 minutos eu estava rodando de novo. Salvou meu dia de entregas.",
    time: "há 3 semanas",
  },
];

export default function Testimonials() {
  return (
    <section id="depoimentos" data-testid="testimonials-section" className="relative py-24 sm:py-32 bg-[#0b0d10]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
            <div>
              <div className="flex items-center gap-2.5 mb-4">
                <GoogleG className="w-5 h-5" />
                <p className="font-tech text-xs uppercase tracking-[0.25em] text-[#e8112d] font-semibold">
                  Avaliações do Google
                </p>
              </div>
              <h2 className="font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl text-slate-100">
                Do desespero ao alívio, em minutos
              </h2>
            </div>
            <div className="flex items-center gap-5" data-testid="google-rating-summary">
              <span className="font-display font-extrabold text-6xl text-slate-100">5.0</span>
              <div>
                <Stars />
                <p className="font-tech text-[11px] uppercase tracking-[0.18em] text-slate-500 mt-2">
                  nota no Google
                </p>
              </div>
            </div>
          </div>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-5">
          {testimonials.map((t, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <blockquote
                data-testid={`testimonial-card-${i}`}
                className="card-metal metal-edge-top rounded-2xl border border-white/5 p-7 h-full flex flex-col hover:border-[#e8112d]/30 transition-colors duration-300"
              >
                <div className="flex items-center justify-between mb-5">
                  <div className="flex items-center gap-3">
                    <span className="w-10 h-10 rounded-full bg-[#e8112d]/15 border border-[#e8112d]/30 flex items-center justify-center font-display font-bold text-sm text-[#ff2d44]">
                      {t.name.charAt(0)}
                    </span>
                    <div>
                      <p className="font-semibold text-slate-100 text-sm leading-tight">{t.name}</p>
                      <p className="font-tech text-[10px] uppercase tracking-[0.16em] text-slate-500 mt-0.5">
                        {t.car} · {t.time}
                      </p>
                    </div>
                  </div>
                  <GoogleG className="w-5 h-5 opacity-80" />
                </div>
                <Stars />
                <p className="mt-4 text-sm sm:text-base text-slate-300 leading-relaxed flex-1">“{t.text}”</p>
              </blockquote>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={GOOGLE_PROFILE_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="google-reviews-link"
              className="inline-flex items-center justify-center gap-2.5 bg-white hover:bg-slate-200 text-black font-bold text-sm sm:text-base px-8 py-4 rounded-full transition-all duration-300 hover:scale-[1.03]"
            >
              <GoogleG className="w-5 h-5" />
              Ver avaliações no Google
            </a>
            <a
              href={GOOGLE_REVIEW_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="google-review-cta"
              className="inline-flex items-center justify-center gap-2 border border-white/15 hover:border-[#e8112d]/60 text-slate-200 hover:text-white font-semibold text-sm sm:text-base px-8 py-4 rounded-full transition-all duration-300 hover:bg-white/5"
            >
              Avalie a NVS no Google
              <ArrowUpRight className="w-4 h-4" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
